import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCalenderDetail } from "../../../redux/getReducer/getRaceCalenderDetail";
import Lottie from "lottie-react";
import Animate from "../../../assets/loader.json";

import {
  getCenturyEnd,
  getDecadeEnd,
  getNextCenturyStart,
  getNextDecadeStart,
  getNextMonthStart,
  getNextYearStart,
  getPreviousCenturyStart,
  getPreviousDecadeStart,
  getPreviousMonthStart,
  getPreviousYearStart,
} from "@wojtekmaj/date-utils";
import { startOfMonth } from "date-fns";
import Cookies from "js-cookie";
import moment from "moment";
import Accordion from "react-bootstrap/Accordion";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import flagimg from "../../../assets/United Arab Emirates.png";
import horse from "../../../assets/Frame.png";
import { MdKeyboardArrowRight } from "react-icons/md";
const CalenderComponent = ({ CalenderData, setRaceCardData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cookiedata = Cookies.get("i18next");
  const now = new Date();
  const startOfCurrentMonth = startOfMonth(now);
  const { t } = useTranslation();

  const [btnData, setbtnData] = useState(false);

  const formatMonthYear = new Intl.DateTimeFormat(undefined, {
    month: "long",
    year: "numeric",
  }).format;

  const formatYear = new Intl.DateTimeFormat(undefined, {
    year: "numeric",
  }).format;

  const [activeStartDate, setActiveStartDate] = useState(startOfCurrentMonth);
  const [view, setView] = useState("month");

  const prevPeriod = (() => {
    switch (view) {
      case "month":
        return getPreviousMonthStart(activeStartDate);
      case "year":
        return getPreviousYearStart(activeStartDate);
      case "decade":
        return getPreviousDecadeStart(activeStartDate);
      case "century":
        return getPreviousCenturyStart(activeStartDate);
      default:
    }
  })();

  const nextPeriod = (() => {
    switch (view) {
      case "month":
        return getNextMonthStart(activeStartDate);
      case "year":
        return getNextYearStart(activeStartDate);
      case "decade":
        return getNextDecadeStart(activeStartDate);
      case "century":
        return getNextCenturyStart(activeStartDate);
      default:
    }
  })();

  function getLabel(date) {
    switch (view) {
      case "month":
        return formatMonthYear(date);
      case "year":
        return formatYear(date);
      case "decade":
        return formatYear(date) + " – " + formatYear(getDecadeEnd(date));
      case "century":
        return formatYear(date) + " – " + formatYear(getCenturyEnd(date));
      default:
    }
  }

  const handleDateClick = () => {
    // const scrollY = window.innerWidth < 530 ? 400 : 250;
    // window.scrollTo({ top: scrollY, behavior: "smooth" });
  };

  const prevLabel = getLabel(prevPeriod);
  const nextLabel = getLabel(nextPeriod);

  const aaaaa = new Date(prevLabel).getMonth();

  const monthnumber = aaaaa - 2;

  function onActiveStartDateOrViewChange({
    activeStartDate: nextActiveStartDate,
    view: nextView,
  }) {
    setActiveStartDate(nextActiveStartDate);
    setView(nextView);
  }

  const { data: CalenderDetail, status: calenderDetailStatus } = useSelector((state) => state.CalenderDetail);

  const [userIsDesktop, setUserIsDesktop] = useState(true);

  const [state, setState] = useState(false);
  useEffect(() => {
    window.innerWidth > 840 ? setUserIsDesktop(true) : setUserIsDesktop(false);
  }, [userIsDesktop]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [FormatDate, setFormatDate] = useState("");

  const FormatedDateArray =
    CalenderData &&
    CalenderData?.map((item, i) => {
      return {
        RaceCourseData: item?.RaceCourseData,
        start: moment(item.start).local().format("YYYY-MM-DD HH:mm:ss"),
      };
    });

  const formattedDates = CalenderData
    ? CalenderData.map((dateObj) => {
      const inputDateString = dateObj.start;
      const inputDate = new Date(inputDateString);

      const options = {
        weekday: "short",
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "long",
        timeZoneOffset: "numeric",
      };

      return {
        start: new Intl.DateTimeFormat("en-US", options).format(inputDate),
      };
    })
    : [];

  const eventList = FormatedDateArray
    ? FormatedDateArray.map((item) => {
      return {
        date: new Date(item.start),
        datetimedata: new Date(item.end),
        title: item.RaceCourse,
        racename: item.RaceNameModelData ? (
          item.RaceNameModelData?.title
        ) : (
          <></>
        ),
        racecoursecolor: item.RaceCourseData ? (
          item.RaceCourseData?.ColorCodeData?.Color
        ) : (
          <></>
        ),
        racecoursename: item.RaceCourseData ? (
          item.RaceCourseData.TrackNameEn
        ) : (
          <></>
        ),
      };
    })
    : [];

  const getEventsForDate = (date) => {
    return eventList.filter(
      (event) => event.date.toDateString() === date.toDateString(),
    );
  };

  const tileContent = ({ date }) => {
    const events = getEventsForDate(date);
    if (events.length > 0) {
      return (
        <button
          className="eventdata1"
          style={{
            backgroundColor: events[0].racecoursecolor,
          }}
        ></button>
      );
    }
    return null;
  };

  const tileClassName = ({ date }) => {
    const events = getEventsForDate(date);
    if (events.length > 0) {
      return "bgcolor";
    }
    return "";
  };

  function formatAMPM(date) {
    const DataDate = new Date(date);
    var hours = DataDate.getHours();
    var minutes = DataDate.getMinutes();
    var ampm = hours >= 12 ? t("PM") : t("AM");
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }

  const eventListForSelectedDate = getEventsForDate(selectedDate);
  const onDateChange = (date) => {
    setSelectedDate(date);
    setFormatDate(date);
    // Immediately fire the API call on click so data arrives faster
    dispatch(fetchCalenderDetail({ start: date }));

    // Auto-navigate logic
    const events = getEventsForDate(date);
    if (events.length === 1) {
      const eventItem = CalenderDetail.find(item =>
        new Date(item.start).toDateString() === date.toDateString()
      );
      if (eventItem) {
        handleAddEvent(eventItem, date);
      }
    }
  };

  const localDate = new Date(selectedDate);
  const utcDate = new Date(
    localDate?.getTime() - localDate?.getTimezoneOffset() * 60000,
  );
  const start = selectedDate;

  useEffect(() => {
    dispatch(fetchCalenderDetail({ start }));
  }, [dispatch, start]);

  let datacheck = 1;
  function dateToBinary(date) {
    const timestamp = date?.getTime(); // milliseconds since epoch
    return timestamp.toString(2); // convert to binary
  }

  function handleAddEvent(allEvents, specificDate) {
    const targetDate = specificDate || selectedDate || FormatDate;
    navigate(`/${allEvents._id}#${dateToBinary(targetDate)}`);
  }

  // drop down scroll

  return (
    <div>
      <Calendar
        value={selectedDate}
        onChange={onDateChange}
        tileContent={tileContent}
        onActiveStartDateChange={onActiveStartDateOrViewChange}
        onViewChange={onActiveStartDateOrViewChange}
        tileClassName={tileClassName}
        onClickDay={handleDateClick}
        tileDisabled={({ date }) => getEventsForDate(date).length === 0}
      />
      <div className="my-new-event-main-wrapper">
        {/* <h2 className="my-new-event-heading">
        On{" "}
        {selectedDate.toDateString("ar", {
            year: "numeric",
            month: "long",
            day: "numeric",
        })}
    </h2> */}

        {calenderDetailStatus === 'loading' ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px 0" }}>
            <Lottie
              animationData={Animate}
              style={{ width: "90px", height: "90px" }}
              loop={true}
            />
          </div>
        ) : CalenderDetail && CalenderDetail.length > 0 ? (
          <div className="my-new-current-post-container">
            {/* --- List of Race Cards --- */}
            {CalenderDetail.map((item, index) => {
              return (
                <div className="custom-event-card-wrapper" key={index}>
                  <div className="my-new-competition-wrapper">
                    <Accordion className="my-new-custom-accordion">
                      <Accordion.Item eventKey="0" className="my-new-acc-item">
                        <Accordion.Header
                          onClick={() => handleAddEvent(item, selectedDate)}
                          className="my-new-acc-header"
                        >
                          <div className="my-new-card-content">
                            <p className="my-new-track-name">
                              {cookiedata === "en"
                                ? item.TrackNameEn
                                : item.TrackNameAr}
                            </p>
                            <p className="my-new-track-date">
                              {selectedDate?.toLocaleDateString("en-GB", {
                                weekday: "long",
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              })}
                            </p>

                            {/* View Race Details Button */}
                            <div className="my-new-view-race-btn">
                              <img src={horse} alt="horse" className="my-new-view-race-horse-icon" />
                              <span>{t("Click To View Race Card")}</span>
                              <MdKeyboardArrowRight className="my-new-view-race-arrow" />
                            </div>
                          </div>
                          <span
                            className="my-new-bottom-accent-bar"
                            style={{
                              background: `${item.ColorCodeData?.Color || "#3b82f6"
                                }`,
                            }}
                          ></span>
                        </Accordion.Header>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="no-race-date">{t("No Race For This Date")}</p>
        )}
      </div>
    </div>
  );
};

export default CalenderComponent;
